import type { Func } from '@ricoh/ria.client.core/types/core/function.type';

import { Url } from '@ricoh/ria.client.core/utils/es/url';

import type { ServiceServerApiConfig, ServiceServerApiModule } from './_config.type';

import serviceServerConfigBase from '../_config';

/**
 * Create ServiceServer Api request config.
 *
 * @template TEndpoints Endpoints config.
 * @param {ServiceServerApiModule} moduleName Request module name.
 * @param {Func<[keyBase: string], TEndpoints>} createEndpoints Endpoints config creator.
 *
 * @returns {ServiceServerApiConfig<TEndpoints>} ServiceServer Api request config.
 */
export default function createRequestConfig<TEndpoints extends Record<string, unknown>>(
  moduleName: ServiceServerApiModule,
  createEndpoints: Func<[keyBase: string], TEndpoints>,
): ServiceServerApiConfig<TEndpoints> {
  const module = `api.${moduleName}` as const;

  const keyBase = new Url()
    .resolve(import.meta.env.APP_SERVER_BASE_WEB)
    .resolve(import.meta.env.APP_SERVER_PATH_API)
    .toString();

  return {
    module,
    options: serviceServerConfigBase.options(keyBase),
    endpoints: createEndpoints(keyBase),
    createError: serviceServerConfigBase.createError(module),
  };
}
